import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import type { MeasurementAggregationRule, MeasurementBucketGranularity } from "@/lib/measurement-aggregation";
export interface MeasurementBucketing {
  granularity: MeasurementBucketGranularity;
  /** The user's selection, kept so it survives a trip through NONE. */
  rule: MeasurementAggregationRule;
  /**
   * The rule to actually aggregate with. Forced to LATEST at NONE, where the
   * combine options are disabled and the trigger label drops the rule — so
   * two readings that happen to share a timestamp are not silently summed
   * under a control that says it is not grouping anything.
   */
  effectiveRule: MeasurementAggregationRule;
  setGranularity: (granularity: MeasurementBucketGranularity) => void;
  setRule: (rule: MeasurementAggregationRule) => void;
}

/**
 * Runtime time-bucket choice for a measurement group. Defaults to DAY + LATEST,
 * which reproduces the fixed grouping the card had before the choice existed.
 *
 * Lifted into a hook so the group card can share one selection between its
 * Table/Chart/Cards body and the per-field trend charts below it.
 */
export function useMeasurementBucketing() {
  const $ = _c(4);
  const [granularity, setGranularity] = useState("DAY");
  const [rule, setRule] = useState("LATEST");
  const t0 = granularity === "NONE" ? "LATEST" : rule;
  let t1;
  if ($[0] !== granularity || $[1] !== rule || $[2] !== t0) {
    t1 = {
      granularity,
      rule,
      effectiveRule: t0,
      setGranularity,
      setRule
    };
    $[0] = granularity;
    $[1] = rule;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}